import type { ReactNode } from 'react'

import { TableSectionProvider } from '../table-section.context'

type Props = {
  children: ReactNode
}

const api = {
  variant: 'body',
} as const

export const TableBody = ({ children }: Props) => (
  <TableSectionProvider value={api}>
    <tbody data-testid="table-body">{children}</tbody>
  </TableSectionProvider>
)
